import * as React from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { cn } from "../../lib/utils";
import { Button } from "./button";
import { Calendar } from "./calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

export function DatePicker({ value, onChange, placeholder = "Pick a date", className, disabled, disabledDates, id, endMonth }) {
  const parsed = value ? (typeof value === "string" ? new Date(value) : value) : undefined;
  // Guarded: format() throws on an invalid date.
  const date = parsed && !Number.isNaN(parsed.getTime()) ? parsed : undefined;
  const handleSelect = (d) => onChange?.(d);
  // `disabled` (boolean) disables the whole button; `disabledDates` (fn/Date) disables individual calendar days
  const buttonDisabled = typeof disabled === "boolean" ? disabled : false;
  const calendarDisabled = disabledDates ?? (typeof disabled === "function" ? disabled : undefined);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          id={id}
          variant="outline"
          disabled={buttonDisabled}
          className={cn("w-full justify-start text-left font-normal", !date && "text-muted-foreground", className)}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date ? format(date, "PPP") : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={date}
          onSelect={handleSelect}
          disabled={calendarDisabled}
          captionLayout="dropdown"
          startMonth={new Date(2023, 0)}
          endMonth={endMonth ?? new Date()}
          defaultMonth={date ?? new Date()}
        />
      </PopoverContent>
    </Popover>
  );
}
